<template>
  <b-row align-h="center">
    <b-col sm="12" md="6" lg="4">
      <h2>Reset Password</h2>
      <b-form @submit="onSubmit">
        <b-form-group label="Email address:">
          <b-form-input v-model="form.email" required placeholder="Email"/>
          <b-form-invalid-feedback
            v-if="formErrors && formErrors.email && formErrors.email.length > 0" :state="false">
            <p v-for="(e, $index) in formErrors.email" :key="$index">{{e}}</p>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="New password">
          <b-form-input v-model="form.password" required placeholder="New password" type="password"/>
          <b-form-invalid-feedback
            v-if="formErrors && formErrors.password && formErrors.password.length > 0" :state="false">
            <p v-for="(e, $index) in formErrors.password" :key="$index">{{e}}</p>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Confirm new password">
          <b-form-input v-model="form.password_confirmation" required placeholder="Confirm new password" type="password"/>
          <b-form-invalid-feedback
            v-if="formErrors && formErrors.password_confirmation && formErrors.password_confirmation.length > 0" :state="false">
            <p v-for="(e, $index) in formErrors.password_confirmation" :key="$index">{{e}}</p>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button type="submit" variant="primary" :disabled="formLoading">
          <b-spinner v-show="formLoading" small label="Small Spinner"></b-spinner>
          Reset password
        </b-button>

        <b-alert class="mt-3" :show="this.formError && this.formError.length > 0"
          variant="danger" dismissible>
          {{ this.formError }}
        </b-alert>

      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import formsMixin from '@/mixins/forms';

export default {
  mixins: [formsMixin],
  props: {
    token: {
      type: [String],
      required: true,
    },
  },
  data() {
    return {
      storeDispatchTarget: 'AuthStore/resetPassword',
      routerTarget: { name: 'login', params: { message: 'Pasword reset successfully' } },
      form: {
        email: '',
        token: '',
        password: '',
        password_confirmation: '',
      },
      formErrors: {
        email: null,
        token: null,
        password: null,
        password_confirmation: null,
      },
    };
  },
  created() {
    // copy the props data
    this.form.token = this.token;
  },
};
</script>
